import React, { Component } from 'react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination, Virtual } from 'swiper/modules';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { getFactionTextureUrl, getTextureUrl } from '../../Common/TextureTools';

import 'swiper/css';
import 'swiper/css/navigation';
import './inventory-selector.css';
import '../../Controls/ticker.css';


class Transcript extends Component {
    render() {
        return <div className={'outcome-flex'}>
            <div className={'ticker-player-container'}>
                <div className={'ticker-player-text'}>
                    <div>{this.props.transcript.game_player.name}</div>
                </div>
                <img src={getFactionTextureUrl(this.props.transcript.game_player.faction)}
                     alt={`player`}
                     className={'ticker-player-image'}/>
            </div>
            <img src={getTextureUrl(this.props.transcript.subject)}
                 alt={`subject`}
                 className={'outcome-image'}/>

            {this.props.transcript.to_game_player &&
                <div className={'ticker-player-container'}>
                    <div className={'ticker-player-text'}>
                        <div>{this.props.transcript.to_game_player.name}</div>
                    </div>
                    <img src={getFactionTextureUrl(this.props.transcript.to_game_player.faction)}
                         alt={`player`}
                         className={'ticker-player-image target-outcome-image'}/>
                </div>
            }

            {this.props.transcript.outcomes.map((textureId, index) => {
                return <img key={index} src={getTextureUrl(textureId)}
                            alt={`texture-${textureId}`}
                            className={'outcome-image'}/>;
            })}
        </div>
    }
}


export default class TranscriptTicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transcripts: [],
        };
        this.swiper = null;
    }

    componentDidMount() {
        window.addEventListener('transcript-message-event',
            this.receiveMessage);
    }

    componentWillUnmount() {
        window.removeEventListener('transcript-message-event',
            this.receiveMessage);
    }


    receiveMessage = (e) => {
        const receivedMessage = e.detail;
        let transcript = receivedMessage.package.data.transcript;
        // if (transcript.outcomes) {
        if (this.swiper && !this.swiper.autoplay.running) {
            this.swiper.autoplay.start();
        }

        if (this.swiper && this.swiper.slides.length - this.swiper.activeIndex > 10) {
            // delay = 0;
            this.swiper.slideTo(this.swiper.slides.length - 10);
            this.swiper.autoplay.start();
        }
        let newTranscripts = [ ...this.state.transcripts, transcript ].slice(-4);
        this.setState({ transcripts: newTranscripts });
        // }
    };

    render() {
        // console.log('TICKER RENDER', this.swiper && this.swiper.slides.length, this.swiper && this.swiper.activeIndex);
        let delay = 200;
        return (
            <div className={'ticker-container'}>
                <div className={'ticker-selector-anchor'}>
                    <div>
                        <Swiper
                            slidesPerView={3}
                            spaceBetween={30}
                            centeredSlides={true}
                            navigation={true}
                            // modules={[Navigation]}

                            // slidesPerView={6}
                            // watchSlidesProgress={true}
                            // spaceBetween={30}
                            grabCursor={true}
                            onSwiper={(swiper) => {
                                this.swiper = swiper;
                            }}
                            // onClick={this.onClick}
                            // className="swiper-min-height"
                            autoplay={{
                                delay: delay,
                                disableOnInteraction: true,
                                stopOnLastSlide: true,
                                pauseOnMouseEnter: false,
                            }}
                            loop={false}
                            // pagination={{
                            //     clickable: true,
                            // }}
                            modules={[ Autoplay, Pagination, Navigation, Virtual ]}
                            // modules={[Autoplay, Navigation, Virtual]}
                            // modules={[Virtual]}
                            // virtual
                            // freeMode={true}

                            pagination={{
                                type: 'progressbar'
                            }}

                        >
                            {this.state.transcripts.map((transcript, index) => {
                                return <SwiperSlide key={`gi-${index}`}
                                                    virtualIndex={index}
                                                    className={'outcome-slide'}
                                >

                                    <Transcript {...this.props} transcript={transcript}/>
                                    {/* <img */}
                                    {/*     src={'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='} */}
                                    {/*     alt="message" */}
                                    {/*     className={'ticker-image'} */}
                                    {/* /> */}
                                </SwiperSlide>;
                            })}

                        </Swiper>
                    </div>
                </div>

            </div>
        );
    }
}
